/**
 * Interface for the Whisper API that will be exposed at window level
 */

export const getWhisper = () => {
  const {
    Whisper
  } = window;
  return Whisper !== null && Whisper !== void 0 && Whisper.version ? Whisper : undefined;
};